const multi = require('../multi/multi');

const time = Object.assign({}, multi, {
    hoursMaxLength: 2,
    hoursComponent: false,
    minutesComponent: false,
    secondsComponent: false,

    inited: function () {
        multi.inited.call(this);

        this.hoursComponent = this.getSubcomponent('hours');
        this.minutesComponent = this.getSubcomponent('minutes');
        this.secondsComponent = this.getSubcomponent('seconds');

        if (this.hoursComponent !== false) {
            this.hoursComponent.element.addEventListener('change', () => { this.dispatchChangeEvents(); });
            this.hoursComponent.element.onfocus = () => { this.hoursComponent.element.select(); };
            if (this.minutesComponent !== false) {
                this.hoursComponent.element.onkeyup = () => { if (this.hoursComponent.element.value.length == this.hoursMaxLength) { this.minutesComponent.element.focus(); } };
            }
        }

        if (this.minutesComponent !== false) {
            this.minutesComponent.element.addEventListener('change', () => { this.dispatchChangeEvents(); });
            this.minutesComponent.element.onfocus = () => { this.minutesComponent.element.select(); };
            if (this.secondsComponent !== false) {
                this.minutesComponent.element.onkeyup = () => { if (this.minutesComponent.element.value.length == 2) { this.secondsComponent.element.focus(); } };
            }
        }

        if (this.secondsComponent !== false) {
            this.secondsComponent.element.addEventListener('change', () => { this.dispatchChangeEvents(); });
            this.secondsComponent.element.onfocus = () => { this.secondsComponent.element.select(); };
        }
    },

    getValue: function () {
        let hours = this.hoursComponent !== false ? parseInt(this.hoursComponent.getValue()) : 0;
        let minutes = this.minutesComponent !== false ? parseInt(this.minutesComponent.getValue()) : 0;
        let seconds = this.secondsComponent !== false ? parseInt(this.secondsComponent.getValue()) : 0;

        return hours * 3600 + minutes * 60 + seconds;
    },

    setValue: function (value) {
        //only implemented for value = int number of seconds; to do: value = time string with format
        if (Number.isInteger(value)) {
            let hours = Math.floor(value / 3600);
            let minutes = Math.floor((value - 3600 * hours) / 60);
            let seconds = value % 60;

            if (this.hoursComponent !== false) {
                this.hoursComponent.setValue(hours);
            }

            if (this.minutesComponent !== false) {
                this.minutesComponent.setValue(minutes);
            }

            if (this.secondsComponent !== false) {
                this.secondsComponent.setValue(seconds);
            }

            this.dispatchChangeEvents();
        }
    }
});

module.exports = time;